import axios from 'axios';
import { createFormDataWithFile, handelResponseError } from '../Utils/utils/CommanFnc';


const loadPatnersData = async(params, type)=>{
    let qParams = new URLSearchParams(params).toString();
    console.log(qParams)
    let url = `/users/vendors/${type}`
    url = `${url}?${qParams}`
    const response = await axios({
        url: url,
        method: "GET",
        headers: {
            "Accept-Language": "en-US,en;q=0.8"
        }
    })
    return response
}

const loadAllDistributors = async({pincode, type})=>{
    let url = `/users/userByPincode/${pincode}/${type}`
    url = `${url}`
    const response = await axios({
        url: url,
        method: "GET",
        headers: {
            "Accept-Language": "en-US,en;q=0.8"
        }
    })
    return response
}

const saveNewPartnersData = async(formData)=>{
    let url = formData._id?"/users/editVendor" :"/users/addVendor"
    let bodyFromData = createFormDataWithFile(formData)
    const response = await axios({
        url: url,
        method: "POST",
        data: bodyFromData,
        headers: {
            "Accept-Language": "en-US,en;q=0.8",
            "Content-Type": "multipart/form-data",
        }
    })
    return response
}

const loadUserData = async(params)=>{
    let qParams = new URLSearchParams(params).toString();
    let url = "/users"
    url = `${url}?${qParams}`
    const response = await axios({
        url: url,
        method: "GET",
        headers: {
            "Accept-Language": "en-US,en;q=0.8"
        }
    })
    return response.data
}

const updatePassword = async(formData) => {
    let url = "/profile/changePassword"
    const response = await axios({
        url: url,
        method: "POST",
        data: formData,
        headers: {
            "Accept-Language": "en-US,en;q=0.8"
        }
    })
    return response
}

const saveUser = async(formData)=>{
    let url = `/users${formData.id?`/${formData.id}`:''}` 
    let bodyFromData = createFormDataWithFile(formData)
    const response = await axios({
        url: url,
        method: `${formData.id?"PATCH":"POST"}`,
        data: bodyFromData,
        headers: {
            "Accept-Language": "en-US,en;q=0.8",
            "Content-Type": "multipart/form-data",
        }
    })
    return response
}

const getPartnerById = async(distributorId, type)=>{
    let url = `/users/vendors/${type}/${distributorId}`
    url = `${url}`
    const response = await axios({
        url: url,
        method: "GET",
        headers: {
            "Accept-Language": "en-US,en;q=0.8"
        }
    })
    return response
}

const getUserById = async(userId)=>{
    let url = `/users/${userId}`
    url = `${url}`
    const response = await axios({
        url: url,
        method: "GET",
        headers: {
            "Accept-Language": "en-US,en;q=0.8"
        }
    })
    return response
}

const getParentUsers = async(params)=>{
    let qParams = new URLSearchParams(params).toString();
    let url = "/users/parentRoleUser"
    url = `${url}?${qParams}`
    const response = await axios({
        url: url,
        method: "GET",
        headers: {
            "Accept-Language": "en-US,en;q=0.8"
        }
    })
    return response.data
}

const getUserCount = async(params)=>{
    let qParams = new URLSearchParams(params).toString();
    console.log("getUserCount")
    let url = "/dashboard"
    url = `${url}?${qParams}`
    const response = await axios({
        url: url,
        method: "GET",
        headers: {
            "Accept-Language": "en-US,en;q=0.8"
        }
    })
    return response
}

const getUserByType = async (params) => {
    let qParams = new URLSearchParams(params).toString();
    let url = `/users/geUsertLatLang?${qParams}`;
    url = `${url}`
    const response = await axios({
        url: url,
        method: "GET",
        headers: {
            "Accept-Language": "en-US,en;q=0.8"
        }
    })
    return response.data
}

const getReplacmentTeamList = async ({userId}) => {
    
    let url = `/users/userByRoleId/${userId}`;
    url = `${url}`
    const response = await axios({
        url: url,
        method: "GET",
        headers: {
            "Accept-Language": "en-US,en;q=0.8"
        }
    })
    return response.data
}

const updateUserPassword = async(formData) => {
    let url = "/users/update-password"
    const response = axios({
        url: url,
        method: "POST",
        data: formData,
        headers: {
            "Accept-Language": "en-US,en;q=0.8"
        }
    }).then((response) => {
        return response?.data;
    }).catch( (error) => {
        return handelResponseError(error);
    })
    
    return response
}

const exports = {
    loadPatnersData,
    getPartnerById,
    saveNewPartnersData,
    loadAllDistributors,
    loadUserData,
    updatePassword,
    saveUser,
    getUserById,
    getParentUsers,
    getUserCount,
    getUserByType,
    getReplacmentTeamList,
    updateUserPassword
}
export default exports;